import * as React from 'react';

import { wrapWithTooltip } from '../wrap_with_tooltip';
import * as styles from './work_experience.css';
import { Checkbox, NumberInput } from '@cian/ui-kit';

interface IWorkExperienceFieldProps {
  isValid: boolean;
  className: string;
  workExperienceValue?: number;
  noWorkExperienceValue: boolean;
  workExperienceChange(value: number): void;
  noWorkExperienceChange(e: React.ChangeEvent<HTMLInputElement>, value: boolean): void;
  workExperienceBlur(): void;
}

const WorkExperienceField = (props: IWorkExperienceFieldProps) => {
  const workExperience: JSX.Element = (
    <span className={styles['container']}>
      <span>от</span>
      <div className={styles['input_container']}>
        <NumberInput
          maxLength={2}
          invalid={!props.isValid}
          value={props.workExperienceValue}
          onBlur={props.workExperienceBlur}
          onChange={props.workExperienceChange}
          min={0}
        />
      </div>
      <span>лет</span>
      <div className={styles['checkbox_container']}>
        <Checkbox
          invalid={!props.isValid}
          label="Можно без опыта"
          checked={props.noWorkExperienceValue}
          onChange={props.noWorkExperienceChange}
        />
      </div>
    </span>
  );

  return (
    <div className={props.className}>
      {props.isValid ? workExperience : wrapWithTooltip(workExperience, 'Укажите минимальный опыт работы')}
    </div>
  );
};

export { WorkExperienceField };
